import React, {useState} from 'react';
import arrow from "../../Media/arrowFAQ.webp"
import "./Question.css";

const Question = ({q, a}) => {
    const [isActive, setIsActive] = useState(false);
    
    return (
        <div onClick = {()=> setIsActive(isActive => !isActive)} className = {`question ${isActive ? "questionActive" : ""}`}>
            <div className = "questionArrowContainer">
                <h3>{q}</h3>
                <img className = {`noSelect questionArrow ${isActive ? "questionArrowActive" : ""}`} src = {arrow} alt="" />
            </div>
            {a}
        </div>
    )
}

export default Question;